import './axios.config';
import { common } from './common';
import { article } from './article';
import { mergeTagService } from './mergeTags';

const services = {
    common,
    article,
    mergeTags: mergeTagService,
};

export default services;
